import dayjs from "dayjs";

/**
 * Recibe una fecha en string y devuelve el formato estandar que estamos trabajando
 * @param {string} date - string
 * @returns
 */
export default function formatDate(date) {
  if (!date) {
    return "no date";
  }
  return dayjs(date).format("DD-MM-YY HH:mm");
}
